//MAIN
import Compressor from 'compressorjs';

// TYPES
import { AnyAction,Dispatch } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { CarObject,Store,Photo } from '../../types';

//Component
import { Toast } from '../../components/Notification'
import Message from '../../components/Message'

// ACTION TYPE
import * as types from '../constants';

//CONSTANTS
import { COMMON_DAMAGES_PART } from '../constants';

//HELPER FUNC
import { Mutation, Queries } from '../../graphql';
import { createName , deleteAllSpaces } from '../../helpers';

//Services
import { uploadImagesToTemporaryStore, setImagesToStore } from '../../services/file-upload';


//MUTATION
import { SEND_USER_FORM , SEND_CLOSE_UP_IMAGES} from '../../graphql/carMutation';
import { PARTNER_DATA, FORM_SUBMIT } from '../../graphql/carQueries';

//HELPERS FUNC
import { getPartnerId } from '../../helpers'

let RESPONSE_COUNT : number = 0
const MESSAGE_ERROR: string = 'Just nu går det inte att få kontakt med bakomliggande system, eller så ger systemet fel. Vänligen kontakta oss om detta problem kvarstår. Vi ber om ursäkt för besväret.';


// HELPER FUNCTION
function dataURLtoFile(dataurl: string, filename: string) {
 
    var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), 
        n = bstr.length, 
        u8arr = new Uint8Array(n);
        
    while(n--){
        u8arr[n] = bstr.charCodeAt(n);
    }
    
    return new File([u8arr], filename, {type:mime});
}

const toBase64 = (file: any) => new Promise((resolve, reject) => {
    const reader : any = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () =>resolve(reader.result);
    reader.onerror = (error:any) => reject(error);
    return reader
})

function compressImages ( payload: any ){
       
    payload.images = payload.images.map((f:any)=>{
                    const file =  dataURLtoFile(f.dataURL,f.file.name)     

                    
                   const a =  new Compressor(file, {
                        height: 180,
                        width: 100,                        
                      });
                      
                   return  a   
            });
        return    payload        
}

function toBase64Images(payload: any) {
    const promiseArr:any = []
    payload.images.forEach((element: any) => {        
        promiseArr.push(toBase64(element.result))
    });

    return Promise.all(promiseArr)
}


function filterCarDamages(arr: CarObject[]): Array<Photo>{
    const images: Array<Photo> = []; 
      
    arr.forEach((item: CarObject)=>{
        const name =  item.name.split('-');
        const isCommonName: boolean = COMMON_DAMAGES_PART.includes(name[2])
        
        const isCarNameExists: boolean = images.some((el: Photo)=>{
            const longName =  el.long_name.split('-');
            
            if(isCommonName&&longName[0]===name[2]) return true;
            if(longName[1]===name[2]&&longName[0]===name[0]) return true;
            
            return false;
        })        

        if(!isCarNameExists){
            const obj: any = {};
            obj['name'] = name[2];            
            obj['images'] = [];
            if(isCommonName) {                
                obj['long_name'] = name[2];
            } else {
                obj['long_name'] = `${name[0]}-${name[2]}`;
            }            
            
            images.push(obj)
        }
    })

    return images;
}

async function fetchCarNumber (carNumber: string ){
   // let token = await this.$apollo.queries.validationSequence.refetch();
   // let currentSequence = token.data.api_current_validation_sequence[0].validation_sequence;

    const url = `https://fordonsinfo.aftenbil.se/carbyregno/${this.RegNo}`;
    const requestHeaders: HeadersInit = new Headers();
    requestHeaders.set('Content-Type', 'application/json');
    requestHeaders.set('x-api-key', 'B3sCJuk0HUyVO5EvQftH3UNn');
    requestHeaders.set('x-api-internal', 'varmsommar2021');
    let r = await fetch(url, {
        headers: requestHeaders,
    });
    return await r.json();
};

// PURE ACTIONS

export function setCarDamages( payload: CarObject[] ): AnyAction {
    return {
        type: types.SET_CAR_DAMAGES,
        payload
    }
}


export function createCarImages ( payload: Array<Photo> ): AnyAction {
    return {
        type: types.CREATE_CAR_IMAGES_LIST,
        payload
    }
}

export function addCarImages ( payload: Array<Photo> ): AnyAction {
    return {
        type: types.ADD_CAR_IMAGES,
        payload
    }
}

export function setCarCoords ( payload: Array<CarObject> ): AnyAction {
    return {
        type: types.SET_CAR_COORDS,
        payload
    }
}

export function setFormText ( payload: any ): AnyAction {
    return {
        type: types.ON_CHANGE,
        payload
    }
}

export function setFormError ( payload: any ): AnyAction {
    return {
        type: types.SET_FORM_ERROR,
        payload
    }
}

export function clearAllData ( payload:any ): AnyAction {
    return {
        type: types.CLEAR_ALL_DATA,
        payload        
    }
}

export function isCarRegistered ( payload: boolean ): AnyAction {
    return {
        type: types.IS_CAR_REGISTERED,
        payload       
    }
}

export function setDamagesZone ( payload: boolean ): AnyAction {
    return {
        type: types.SET_DAMAGES_ZONE,
        payload       
    }
}

export function uploadImage ( payload: boolean ): AnyAction {
    return {
        type: types.UPLOAD_IMAGE,
        payload       
    }
}

export function setPartnerData ( payload: boolean ): AnyAction {
    return {
        type: types.SET_PARTNER_DATA,
        payload       
    }
}

export function setCarName ( payload: string ): AnyAction {
    return {
        type: types.SET_CAR_NAME,
        payload       
    }
}

export function setAdditionDamagePart ( payload: Array<Photo> ): AnyAction {
    return {
        type: types.SET_ADDITION_DAMAGE_PART,
        payload       
    }
}

export function selectOtherPartDamages( payload: boolean ): AnyAction {
    return {
        type: types.SELECT_OTHER_PART_DAMAGES,
        payload       
    }
}

export function formSubmitProcess( payload: boolean ): AnyAction {
    return {
        type: types.FORM_SUBMIT,
        payload       
    }
}


//VALIDATION FUNCTION 
/**
 * 
 * @param form
 * if you need validate something use this function 
 */

function validateEmail(email: string) {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
} 

function validation(form: any){
    const error: string[] = [];
    if( form.reg_nr==='' || !form.reg_nr){
        error.push('reg_nr');
    } else if (form.meter_reading ==='' || !form.meter_reading){
        error.push('meter_reading');
    } else if( form.full_name ==='' || !form.full_name){
        error.push('full_name');
    } else if (form.email==='' || !form.email || !validateEmail(form.email) ){
        error.push('email');
    } else if (form.phone ==='' || !form.phone){
        error.push('phone');       
    } else if (form.date ==='' || !form.date){
        error.push('date');     
    } else error

    return error
}

// ACTIONS WITH SIDE EFFECT

export function fetchPartnerData (payload: any): ThunkAction<void, Store, any, AnyAction> {

    return (dispatch: Dispatch, getStore ): void=>{  
        const partner_id = getPartnerId();
        
        Queries(PARTNER_DATA,{partner_id})
        .then((res:any)=>{            
            dispatch(setPartnerData(res.data.damage_partner[0]));
            const partner =  res.data.damage_partner[0];  
                 
            document.documentElement.style.setProperty('--color_primary', partner.color_primary?partner.color_primary:'#274D82');
            document.documentElement.style.setProperty('--color_secondary', partner.color_secondary?partner.color_secondary:'#F2F9FF');
            document.documentElement.style.setProperty('--color_highlight', partner.color_highlight?partner.color_highlight:'#00CC83');
            document.documentElement.style.setProperty('--color-parts-highlight', partner.color_damage_selection?partner.color_damage_selection:'red');
        }).catch((e: any)=>{
            console.log(e)
        })
    }
}

export function setAdditionPart(payload:boolean): ThunkAction<void, Store, any, AnyAction> {

    return (dispatch: Dispatch,getStore): void=>{          

        const close_ups = getStore().car.photos.close_ups;

        dispatch(selectOtherPartDamages(payload))

        if(payload) {
            const other_part:any = {};

            other_part.name = 'other_part';
            other_part.images = [];
            other_part.long_name='other_part';                        
            
            close_ups.push(other_part)

            dispatch(setAdditionDamagePart(close_ups));
        } else {
            const filterOtherPart =  close_ups.filter((item)=>{
                if(item.name === 'other_part') return false
                return true
            })            
            dispatch(setAdditionDamagePart(filterOtherPart));
        }        
    }
}

export function setText(payload: any): ThunkAction<void, Store, any, AnyAction> {

    return (dispatch: Dispatch, getStore ): void=>{       
        const form = {...getStore().car.form};
        form[payload.name] = payload.value;
        dispatch(setFormError(validation(form)));       
        dispatch(setFormText(payload));
    }
}

function normalizeSubmitForm(obj : any){    
    obj['meter_reading'] =  Number(obj['meter_reading']);
    if(obj['postal_code']) obj['postal_code'] =  Number(obj['postal_code']);   

    return obj;
}


async function uploadCloseUpsImagesToHasura(closeUps:any , form_id: string,){
    const promiseArr: Array<Promise<any>> = [];

    closeUps.forEach((link:string)=>{       
        const name = link.split('/');
        const imageName = name[name.length-1].split('__');
        
        const payload: any = {}
        payload.area_closeup_image_url = link;
        payload.area_name = imageName[1];
        payload.form_submit_id = form_id;        

        promiseArr.push(Mutation(SEND_CLOSE_UP_IMAGES, payload))       
    })

    return await Promise.all(promiseArr)
}

export function submitFormUser (resetSteps: any) : ThunkAction<void, Store, any, AnyAction> { 
    
    return (dispatch: Dispatch, getStore ): void=>{        
        const { car: { form : { errors, carRegistration, ...payload }, coords , sessionUniqueId ,partner , ownCar : { brand , series , model } }  }: any =  getStore();       
        try {    
            
            let registrationNumber = document.getElementById("reg_nr") as HTMLInputElement;
            payload.reg_nr = registrationNumber.value;
            console.log(payload)
            dispatch(formSubmitProcess(true))
            setImagesToStore(sessionUniqueId, partner.partner_id, payload.reg_nr)
                .then((res:any)=>{                    
                    const overView:any = [];
                    const closeUps:any = []
                     
                    const arrWithImages = res.data.map((url: string)=>{
                        return url.replace(/https:\//gi,'https://')
                    })
                     
                    arrWithImages.forEach((t: string)=>{
                        const a = t.split('/')
                        const shortCut = a[a.length-1]
                        if(shortCut.split('__')[0]==='overview'){
                            overView.push(t);
                        }else {
                            closeUps.push(t);
                        }
                    })                  
                    
                    payload.overview_image_url = overView[0];
                    payload.partner_id = partner.partner_id;
                    payload.session_id = sessionUniqueId;
                    payload.make = brand;
                    payload.model = series;
                    payload.model_specific = model;
                    
                    
                    Mutation(SEND_USER_FORM, normalizeSubmitForm(payload))
                    .then((res:any)=>{
                        const { id }: any = res.data.insert_damage_form_submit.returning[0]; 
                        
                        uploadCloseUpsImagesToHasura(closeUps, id).then((res:any)=>{                            
                            if(res.status>400){
                                Toast('error', MESSAGE_ERROR);
                                dispatch(formSubmitProcess(false))
                            }

                            resetSteps();                            
                            const resetCoords = coords.map((item:any)=>{
                                item.active =false
                                return item
                            })
                            localStorage.removeItem('persist:root');
                            dispatch(clearAllData(resetCoords));
                            dispatch(formSubmitProcess(false));
                            Queries(FORM_SUBMIT,{id}).then((res: any)=>{                                                               
                                parent.postMessage(JSON.stringify(res.data.damage_form_submit[0]),'*');
                            }).catch((e:any)=>{                            
                                dispatch(formSubmitProcess(false))
                                Toast('error', MESSAGE_ERROR)
                            }) 
                        }).catch((e:any)=>{                            
                            dispatch(formSubmitProcess(false))
                            Toast('error', MESSAGE_ERROR)
                        })                        
                    })
                    .catch((e:any)=>{
                        dispatch(formSubmitProcess(false))
                        Toast('error', MESSAGE_ERROR)
                    })
                }).catch((e:any)=>{
                    dispatch(formSubmitProcess(false))
                    Toast('error', MESSAGE_ERROR)
                })            
                      
        }catch(e){
            Toast('error', MESSAGE_ERROR)
            dispatch(formSubmitProcess(false))
        }        
    }
}


export function checkCarNumber(): ThunkAction<void, Store, any, AnyAction> {

    return (dispatch: Dispatch, getStore ): void=>{ 
        const {reg_nr, carRegistration} = getStore().car.form  
        dispatch(setCarName(''));
        
        try{
            if(!reg_nr){
                Toast('info','Bil med detta reg.nr hittades inte');
                dispatch(isCarRegistered(false));
            } else {
                if(true){
                   if(RESPONSE_COUNT) return;   
                   
                    fetchCarNumber(deleteAllSpaces(reg_nr))
                        .then((resp) => resp.json())
                        .then((r)=>{
                            if(r.result.car_name){
                                dispatch(isCarRegistered(!!r.result.car_name)); 

                                const  obj: any =  {};
                                obj.carName = r.result.car_name;
                                obj.brand = r.result.brand;
                                obj.series = r.result.series;
                                obj.model = r.result.model;
                                dispatch(setCarName(obj));
                            }                            
                            RESPONSE_COUNT = 0;
                        })
                        .catch((error)=>{
                            RESPONSE_COUNT = 0;
                            Toast('error',`Bil med detta reg.nr hittades inte`);
                            dispatch(setCarName(''));
                        })
                        ++RESPONSE_COUNT;
                }                
            }

        }catch(e){            
            Toast('error', MESSAGE_ERROR)
        }
    }
}

// TO DO UPLOAD IMAGES
export function addDamageCar(payload:CarObject[]): ThunkAction<void, Store, any, AnyAction> {

    return (dispatch: Dispatch, getStore ): void=>{            
        const close_ups = getStore().car.photos.close_ups;
        const filterOtherPart = close_ups.filter((item: any)=>{
            if(item.name==='other_part') return true
        })
        const concatArr = filterCarDamages(payload).concat(...filterOtherPart);
        
        dispatch(createCarImages (concatArr));
        dispatch(setCarDamages(payload));
        
    }
}

async function createUploadFlow(arr:any , tempUniqueSessionId: string, type:string, long_name:string){
    const promiseArr:any = [];

    arr.forEach((f:any)=>{        
        const formData = new FormData();

        if (f.temporaryUrl) return;

        const name : string  =  createName(type , long_name , f.file.name);        
        formData.append(name, f.file, name);
        promiseArr.push(uploadImagesToTemporaryStore(formData,tempUniqueSessionId));       
    })

    return await Promise.all(promiseArr)
}



export function setCarImages(payload:any ): ThunkAction<void, Store, unknown, AnyAction> {

    return (dispatch: Dispatch, getState ): void=>{
        
        const {car: { photos: {close_ups}, sessionUniqueId }} : Store = getState();
        dispatch(uploadImage(true))
        
        if(payload.key==='overview'){                          
                if(payload.images.length){
                    
                    createUploadFlow(payload.images, sessionUniqueId, payload.key, payload.long_name)
                    .then((res:any)=>{
                        if(res.status>400 || res.status === 500){
                            Toast('error', MESSAGE_ERROR);
                            dispatch(uploadImage(false));
                        }                        
                        payload.images = payload.images.map((item: any)=>{                            
                            const obj:any = {};                            
                            item['temporaryUrl'] = res[0].config.url;
                            obj['images'] = [item];                            
                            obj['long_name'] = payload.long_name;
                            obj['name'] = payload.long_name; 

                            return obj;
                        })                         
                        const file =  dataURLtoFile(payload.images[0].images[0].dataURL,payload.images[0].images[0].file.name)

                        new Compressor(file, {
                            height: 180,
                            width: 100,
                            success(result) {
                                const reader = new FileReader();
                                reader.readAsDataURL(result);                                
                                reader.onload = (e) => {
                                    payload.images[0].images[0].dataURL = reader.result;
                                    payload.images[0].images[0].file = result;                                    
                                    dispatch(uploadImage(false));                                                                  
                                    dispatch(addCarImages(payload));
                                    
                                };                                
                            },
                            error(err) {
                              console.log(err.message);
                            },
                          });                                              
                    })
                    .catch((e)=>{
                        dispatch(uploadImage(false))
                        Toast('error', MESSAGE_ERROR);
                    })                   
                } else {
                    const defaultObject:any = { }
                    defaultObject.images = [];
                    defaultObject['long_name'] = payload.long_name;
                    defaultObject['name'] = payload.long_name
                    payload.images.push(defaultObject)
                    dispatch(addCarImages(payload));
                    dispatch(uploadImage(false))
                }            

            
        } else {
            createUploadFlow(payload.images, sessionUniqueId, payload.key, payload.long_name)
            .then((res: any)=>{  
                if(res.length===0) return;
                if(res.status>400 || res.status === 500){
                    Toast('error', MESSAGE_ERROR);
                    dispatch(uploadImage(false));
                }
                                
                const newArr = payload.images.map((f:any)=>{                    
                    f['temporaryUrl'] = res[0].config.url; 

                    return f
                });

                newArr.images = payload.images.map((f:any, index: number)=>{
                    const file =  dataURLtoFile(f.dataURL,f.file.name)                   
                   new Compressor(file, {
                        height: 180,
                        width: 100,
                        success(result: any) {              
                          const reader : any = new FileReader();
                          
                            reader.readAsDataURL(result);
                            reader.onload = () =>{                                
                                const newPayload : any = payload

                                newPayload.images =  newPayload.images.map((el: any)=>{
                                    if(el.file.name === result.name){
                                        el.file = result;
                                        el.dataURL = reader.result;
                                        return el
                                    }
                                    return el
                                })                               

                                const updatedPhotos = close_ups.map((item: Photo)=>{                
                                    if(newPayload.long_name === item.long_name) {
                                        item.images = newPayload.images ;
                                    }   
                                        return item
                                    })
                
                                dispatch(uploadImage(false));         
                                dispatch(addCarImages(updatedPhotos));  

                            }
                        }
                                                
                      }
                      );                     
                     
            });                            
            })
            .catch((e)=>{                
                dispatch(uploadImage(false))
                Toast('error', MESSAGE_ERROR);
            })

            const updatedPhotos = close_ups.map((item: Photo)=>{                
                    if(payload.long_name === item.long_name) {
                        item.images = payload.images ;
                    }
                
    
                return item
            })            

            dispatch(addCarImages(updatedPhotos));
        }        
    }
}